import styled from '@emotion/styled';
import { Text, Icon, tokens } from '@hotjar/hotsauce';
import type { PriceSummary } from '@hotjar/webapp/billing/subscription';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { PlansCostNewSummary } from '../components/PlansCostNewSummary';
import Illustration from './look-at-changes-through-door.svg';

const S = {
  TopContainer: styled.div`
    background-color: ${tokens.color.bg_active};
    display: flex;
    gap: ${tokens.spacer.x2};
    align-items: center;
    padding: ${tokens.spacer.x3};
  `,
  PlansCostNewSummary: styled(PlansCostNewSummary)`
    flex: 1;
  `,
  BottomContainer: styled.div`
    background-color: ${tokens.color.bg_info};
    padding: ${tokens.spacer.x2} ${tokens.spacer.x3};
    display: flex;
    gap: ${tokens.spacer.x2};
    align-items: center;
    border: 1px solid ${tokens.color.ui_border};
    border-radius: ${tokens.radius.l};
  `,
  BottomText: styled(Text)`
    font-weight: 700;
  `,
  LookAtChangesThroughDoor: styled.img`
    padding: 0 ${tokens.spacer.x3};
  `,
};

type CostBreakdown = Pick<PriceSummary, 'tax' | 'total' | 'totalWithTax'>;

interface PlansCostProps {
  payNowPrice: CostBreakdown | undefined;
  payLaterPrice: CostBreakdown | undefined;
  isPsd2?: boolean;
  onPopoverClicked(position: string): void;
}

export function SummaryOfChangesTotals({
  payNowPrice,
  payLaterPrice,
  isPsd2,
  onPopoverClicked,
}: PlansCostProps): JSX.Element {
  const { t } = useTranslationWithPrefix('billing:summary-of-changes');

  return (
    <>
      <S.TopContainer>
        <S.LookAtChangesThroughDoor src={Illustration} alt={t('title')} />
        <S.PlansCostNewSummary
          payNowPrice={payNowPrice}
          payLaterPrice={payLaterPrice}
          onPopoverClicked={onPopoverClicked}
        />
      </S.TopContainer>
      {isPsd2 && (
        <S.BottomContainer>
          <Icon icon="info" />
          <S.BottomText textType="caption">{t('description')}</S.BottomText>
        </S.BottomContainer>
      )}
    </>
  );
}
